import React from 'react';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './DoubleCheckButton.module.css';
import { CommonButton } from '_components';


export class DoubleCheckButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faCheckDouble} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}

